import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';

const actions = {
  async getOrders({ commit }, {
    limit = 10,
    offset = 0,
    companyId,
    filters = {},
    sorting = {},
  } = {}) {
    try {
      const params = new URLSearchParams({
        'pagination[limit]': limit,
        'pagination[offset]': offset,
      });

      if (sorting.field && sorting.order) {
        params.append(`sorting[${sorting.field}][method]`, sorting.order);
        params.append(`sorting[${sorting.field}][order]`, 1);
      } else {
        params.append('sorting[addedAt][method]', 'desc');
        params.append('sorting[addedAt][order]', 1);
      }

      if (companyId) {
        params.append('filters[customerCategoryId]', Number(companyId));
      }

      if (filters.status) {
        params.append('filters[orderStatusCode]', filters.status);
      }

      if (filters.pmUserId) {
        params.append('filters[pm_users.id]', filters.pmUserId);
      }

      const response = await apiCall({
        type: 'GET',
        url: `${URLS.orders}?${params.toString()}`,
        isToken: true,
      });

      const {
        data: {
          data: {
            data: ordersArray,
            total: totalCount,
          },
        },
      } = response;

      commit('GET_ORDERS_SUCCESS', ordersArray);
      if (totalCount !== undefined) {
        commit('SET_ORDERS_TOTAL', Number(totalCount));
      }
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async updateOrder({ dispatch }, {
    order,
    limit,
    offset,
    companyId,
    filters,
    sorting,
  }) {
    try {
      await apiCall({
        type: 'PUT',
        url: `${URLS.orders}/${order.id}`,
        isToken: true,
        data: order,
      });
      notificationWithIcon('success', 'Order updated successfully');
      dispatch('getOrders', {
        limit, offset, companyId, filters, sorting,
      });
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async deleteOrder({ dispatch }, {
    id,
    limit,
    offset,
    companyId,
    filters,
    sorting,
  }) {
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.orders}/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Order deleted successfully');
      dispatch('getOrders', {
        limit, offset, companyId, filters, sorting,
      });
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
};

export default actions;
